import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setFederationId } from '../api/AuthenticationApi';
import { httpRequest } from '../api/CommonApi';
import AppLandingPage from '../components/landingPage/AppLandingPage';
import LoadingOverlay from '../components/LoadingOverlay/LoadingOverlay';
import { getClaimsFromToken, getToken } from '../functions/AuthenticationFunctions';
import { loginSuccess } from '../actions/AuthActions';

const AppLandingPageController = () => {
    const authenticationReducer = useSelector(state =>  ({
        user: state.authenticationReducer.user,
        isLoading: state.authenticationReducer.isLoading
    }));

    const authorizationReducer = useSelector(state => ({
        permissions: state.authorizationReducer.permissions,
        permissionsRetrieved: state.authorizationReducer.fetched,
        isFetching: state.authorizationReducer.isFetching,
        error: state.authorizationReducer.error
    }));

    const dispatch = useDispatch();
    const token = getToken();
    const claims = token && getClaimsFromToken(token);

    useEffect(() => {
        if (token) {
            const redirectTo = sessionStorage.getItem('redirectAfterLogin');
            if (redirectTo != null && claims?.cid != null) {
                sessionStorage.removeItem('redirectAfterLogin');
                window.location.href = `${redirectTo}signin?access_token=${token}`;
            }
            dispatch(loginSuccess());
        }
    }, []);

    const isSalesforceUser = () => {
        if (!token) return false;
        return !!(claims && claims.sf && claims.sf.extUid);
    };

    if (authenticationReducer.isFetching || Object.keys(authenticationReducer.user).length === 0) {
        return <LoadingOverlay loading={true} />;
    } else {
        return (
            <AppLandingPage
                user={authenticationReducer.user}
                error={authorizationReducer.error}
                isLoading={authenticationReducer.isLoading}
                permissions={authorizationReducer.permissions}
                isSalesforceUser={isSalesforceUser()}
                setFederationId={setFederationId}
                httpRequest={httpRequest}
            />
        );
    }
};

export default AppLandingPageController;